/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import CryptoJS from "crypto-js";
import { getEnvs } from "state/EnvironmentsContext/EnvContext";

const DECRYPT_KEY = getEnvs(state=>state.decrypt_key) ;
const IV = getEnvs(state=>state.decrypt_iv);

const decrypt = (text: string) => {
  try {
    var iv = CryptoJS.enc.Utf8.parse(IV!);
    var key = CryptoJS.enc.Utf8.parse(DECRYPT_KEY!);
    var decrypted_value = CryptoJS.AES.decrypt(text || "", key, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: iv,
    }).toString(CryptoJS.enc.Utf8);
    return decrypted_value;
  } catch (err) {
    if (getEnvs(state=>state.environment)  !== "production") {
      console.log("Error in decrypting data: ", err);
    }
    return text;
  }
};

export default decrypt;
